import React from 'react';
import { SubscriptionTrackerPagination } from '../../../types/admin/subscriptionTracker';

interface UserSubPaginationProps {
  pagination: SubscriptionTrackerPagination;
  onOffsetChange: (offset: number) => void;
  onLimitChange: (limit: number) => void;
  showPageSize?: boolean;
}

const PAGE_SIZE_OPTIONS = [25, 50, 100];

const UserSubPagination: React.FC<UserSubPaginationProps> = ({
  pagination,
  onOffsetChange,
  onLimitChange,
  showPageSize = true,
}) => {
  const { offset, limit, total, has_more } = pagination;
  const start = total === 0 ? 0 : offset + 1;
  const end = Math.min(offset + limit, total);

  return (
    <div className="mt-4 flex flex-wrap items-center justify-between gap-4">
      <p className="text-sm text-gray-600">
        {total === 0 ? 'No results' : `Showing ${start}–${end} of ${total}`}
      </p>

      <div className="flex flex-wrap items-center gap-3">
        {showPageSize && (
          <label className="flex items-center gap-2 text-sm text-gray-600">
            Page size
            <select
              className="p-1.5 border border-gray-300 rounded-md bg-white text-sm"
              value={limit}
              onChange={(e) => onLimitChange(Number(e.target.value))}
            >
              {PAGE_SIZE_OPTIONS.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </label>
        )}

        <div className="flex gap-2">
          <button
            type="button"
            disabled={offset === 0}
            onClick={() => onOffsetChange(Math.max(0, offset - limit))}
            className="px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Previous
          </button>
          <button
            type="button"
            disabled={!has_more}
            onClick={() => onOffsetChange(offset + limit)}
            className="px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserSubPagination;
